export default __webpack_public_path__ + "static/media/Frame2.b9a2e09b.svg";